import * as React from 'react';
import { EnterpriseForm } from './EnterpriseForm';
import { SuccsessMessage } from './EnterpriseSuccessMessage';
import { useEnterpriseRefContext } from 'providers/EnterpriseContextProvider';

export const EnterpriseFormSection: React.FC = () => {
  const {
    setRef,
    shouldShowSuccsessMessage,
    showSuccsessMessage,
  } = useEnterpriseRefContext();
  const ref = React.useRef(null);
  React.useLayoutEffect(() => setRef(ref), []);

  return (
    <section ref={ref}>
      {shouldShowSuccsessMessage ? (
        <SuccsessMessage />
      ) : (
        <EnterpriseForm showSuccsessMessage={showSuccsessMessage} />
      )}
    </section>
  );
};
